window.$ = window.jQuery = require('jquery');

import 'jquery';
import 'popper.js';
import 'bootstrap';

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VeeValidate from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';
import CurrencyFormatter from 'currency-formatter';
import Vue2Filters from 'vue2-filters';
import moment from "moment";
import {BigNumber} from "bignumber.js";
import VueClipboard from 'vue-clipboard2';
import VueToastr from '@deveodk/vue-toastr';
import VueSocketIO from 'vue-socket.io';
import VMdDateRangePicker from "v-md-date-range-picker";
import Money from "./models/Money";
import Quantity from "./models/Quantity";
import VueUnits from 'vue-units';
import VueHtmlToPaper from 'vue-html-to-paper';
import {ToWords} from 'to-words';
import pad from "pad"
import VueApexCharts from 'vue-apexcharts';

import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './plugins/i18n';
import categories from './assets/js/goods_category.json';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import UnitSelect from '@/components/protected/common/UnitSelect';

require("./assets/plugins/bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css");
require('@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css');
require("./assets/css/jquery.steps.css");
require("./assets/css/steps.css");
require("./assets/css/steps.css");
require("./assets/css/style.css");
require("./assets/css/vue-multiselect.css");
require("./assets/css/custom.css");
require("./assets/css/select.min.css");
require("./assets/css/select2.min.css");
require("daterangepicker/daterangepicker.css");

require("./assets/js/app");
require("./assets/js/app-style-switcher");
require("./assets/js/waves.js");
require("./assets/plugins/perfect-scrollbar/dist/perfect-scrollbar.jquery.min");
require("./assets/plugins/sparkline/sparkline.js");
require("./assets/plugins/bootstrap-datepicker/dist/js/bootstrap-datepicker.min");
require("daterangepicker/daterangepicker");


Vue.config.productionTip = false;

Vue.prototype.$ACCOUNTS_URL = process.env.VUE_APP_ACCOUNTS_URL;
Vue.prototype.$IDENTITY_URL = process.env.VUE_APP_IDENTITY_URL;
Vue.prototype.$PROVENANCE_URL = process.env.VUE_APP_PROVENANCE_URL;
Vue.prototype.$API_URL = process.env.VUE_APP_API_URL;
Vue.prototype.$SITE_URI = process.env.VUE_APP_SITE_URI;
Vue.prototype.$BORLAUG = process.env.VUE_APP_BORLAUG;
Vue.prototype.$EXPLORER = process.env.VUE_APP_EXPLORER_URL;

const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=no'
    ],
    scripts: [
        'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.14.0/js/all.min.js'
    ],
    styles: [
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
        'https://unpkg.com/kidlat-css/css/kidlat.css',
        'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.14.0/css/all.min.css'
    ]
}

Vue.use(VueHtmlToPaper, options);
Vue.use(VMdDateRangePicker);
Vue.use(Vue2Filters);
Vue.use(VeeValidate);
Vue.use(VueSweetalert2);
Vue.use(VueClipboard);
Vue.use(VueToastr, {
    defaultPosition: 'toast-top-right',
    defaultType: 'info',
    defaultTimeout: 5000
});
Vue.use(VueAxios, axios.create({
    baseURL: Vue.prototype.$API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.token
    }
}));
Vue.use(new VueSocketIO({
    debug: true,
    connection: Vue.prototype.$API_URL
}));
Vue.use(VueUnits);
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(VueApexCharts);

Vue.component('apexchart', VueApexCharts);
Vue.component('unit-select', UnitSelect);

/**
 * Filter for Currency
 */
Vue.filter('money', function (value) {
    return new Money(value).toString();
});
/**
 * Filter for Quantity
 */
Vue.filter('units', function (value) {
    return new Quantity(value).toString();
});
/**
 * Filter for unit conversion
 */
Vue.filter('convert', function (value, toUnit) {
    return new Quantity(value).convert(toUnit).toString();
});
Vue.filter('currency', function (value, symbol) {
    //if(!value) return '';
    value = value.toString();
    return CurrencyFormatter.format(new BigNumber(value).toString(), {symbol: symbol || '$ '});
});
Vue.filter('count', function (value) {
    if (value === undefined || value === null) return '';
    return new BigNumber(value).toString()
});
Vue.filter('unitFix', function (value, precision) {
    if (value === undefined || value === null) return '';
    return new BigNumber(value).toFixed(precision);
});
Vue.filter('fromNow', function (dateString) {
    if (!dateString) return '';
    return moment(dateString).fromNow()
});
Vue.filter('date', function (dateString) {
    if (!dateString) return '';
    return moment(Date.parse(dateString)).format("MMMM Do YYYY");
});
Vue.filter('timestamp', function (dateString) {
    if (!dateString) return '';
    return moment(Date.parse(dateString)).format("MMMM Do YYYY, h:mm:ss a");
});
Vue.filter('long', function (dateString) {
    if (!dateString) return '';
    return moment(Date.parse(dateString)).format("MMM Do, h:mm a");
});
Vue.filter('shorttimestamp', function (dateString) {
    if (!dateString) return '';
    return moment(Date.parse(dateString)).format("MMM Do YYYY, h:mm a");
});
Vue.filter('epoch', function (epochString) {
    return moment.unix(epochString).format('MMM Do YYYY')
});
Vue.filter('medium', function (dateString) {
    if (!dateString) return '';
    return moment(Date.parse(dateString)).format("MMM Do YYYY");
});
Vue.filter('timeline', function (dateString) {
    if (!dateString) return '';
    return moment(Date.parse(dateString)).format("DD/MM/YYYY");
});
Vue.filter('capitalize', function (value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
});
Vue.filter('lowercase', function (value) {
    if (!value) return '';
    value = value.toString();
    return value.toLowerCase()
});
Vue.filter('truncate', function (text, length, suffix) {
    if (text.length <= length) return text;
    return text.substring(0, length) + suffix;
});

const toWords = new ToWords();
Vue.filter('words', function (value) {
    return toWords.convert(value)
});

Vue.filter('invoiceNumber', function (id) {
    let d = new Date();
    let n = d.getFullYear();
    return `INV/${n}/${pad(7, id, '0')}`;
});

Vue.filter('category', function (value) {
    let category = _.filter(categories, {value});
    return category.length > 0 ? category[0].name : '';
});

Vue.filter('did', function (didString) {
    if (!didString) {
        return '';
    }
    return 'did:bws:' + didString.substring(2, didString.length - 2);
});
Vue.filter('hex_format', function (text, length, suffix) {
    if (text.length <= length) return text;
    return text.substring(0, length) + suffix + text.substring(text.length - length);
});

Vue.filter('middle_truncate', function (text, length, suffix) {
    if (text.length <= length * 2) {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();;
    } else {
        let truncated_text = text.substring(0, length) + suffix + text.substring(text.length - length);
        return truncated_text.charAt(0).toUpperCase() + truncated_text.slice(1).toLowerCase();
    }
})


Vue.axios.interceptors.request.use((config) => {
    let token = localStorage.getItem("token");
    config.headers.Authorization = `Bearer ${token}`;
    return config;
}, function (error) {
    return Promise.reject(error)
});


Vue.axios.interceptors.response.use((res) => {
    return res;
}, function (error) {
    if (error.response && error.response.status === 401) {
        window.location.href = "/auth/login";
        console.log(error.response.status);
    }
    return Promise.reject(error)
});

Vue.prototype.$accounts = axios.create({
    baseURL: Vue.prototype.$ACCOUNTS_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'BWS ' + localStorage.getItem("bws_token")
    }
});

Vue.prototype.$accounts.interceptors.request.use((config) => {
    let token = localStorage.getItem("bws_token");
    config.headers.Authorization = `BWS ${token}`;
    return config;
}, function (error) {
    return Promise.reject(error);
});

Vue.prototype.$accounts.interceptors.response.use((res) => {
    return res;
}, function (error) {
    if (error.response && error.response.status === 401) {
        // window.location.href = "/auth/login";
    }
    return Promise.reject(error);
});

Vue.prototype.$identity = axios.create({
    baseURL: Vue.prototype.$IDENTITY_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'BWS ' + localStorage.getItem("bws_token")
    }
});

Vue.prototype.$identity.interceptors.request.use((config) => {
    let token = localStorage.getItem("bws_token");
    config.headers.Authorization = `BWS ${token}`;
    return config;
}, function (error) {
    return Promise.reject(error);
});

Vue.prototype.$identity.interceptors.response.use((res) => {
    return res;
}, function (error) {
    if (error.response && error.response.status === 401) {
        // window.location.href = "/auth/login";
    }
    return Promise.reject(error);
});

Vue.prototype.$provenance = axios.create({
    baseURL: Vue.prototype.$PROVENANCE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'BWS ' + localStorage.getItem("bws_token")
    }
});

Vue.prototype.$provenance.interceptors.request.use((config) => {
    let token = localStorage.getItem("bws_token");
    config.headers.Authorization = `BWS ${token}`;
    return config;
}, function (error) {
    return Promise.reject(error);
});

Vue.prototype.$provenance.interceptors.response.use((res) => {
    return res;
}, function (error) {
    if (error.response && error.response.status === 401) {
        // window.location.href = "/auth/login";
    }
    return Promise.reject(error);
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app'); 
